'use strict';

var anticipate = require('../../../../../../motion-utils/dist/es/easing/anticipate.cjs');
var back = require('../../../../../../motion-utils/dist/es/easing/back.cjs');
var circ = require('../../../../../../motion-utils/dist/es/easing/circ.cjs');

const unsupportedEasingFunctions = {
    anticipate: anticipate.anticipate,
    backInOut: back.backInOut,
    circInOut: circ.circInOut,
};
function isUnsupportedEase(key) {
    return key in unsupportedEasingFunctions;
}
function replaceStringEasing(transition) {
    if (typeof transition.ease === "string" &&
        isUnsupportedEase(transition.ease)) {
        transition.ease = unsupportedEasingFunctions[transition.ease];
    }
}

exports.replaceStringEasing = replaceStringEasing;
//# sourceMappingURL=unsupported-easing.cjs.map
